/* template */
<template><page><base-container><div :class='["icon-page"]'><div v-for="(item, index) in (iconList)" :key="item.index" :class='["icon-item"]'><div :class='["icon-wrapper"]'><icon-example :type="(item)"/></div><div :class='["icon-type"]'>cubeic-{{item}}</div></div></div></base-container></page></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_742367df"}'>
.icon-page
  display flex
  flex-wrap wrap
  .icon-item
    width 50%
    font-size 32px
    text-align center
    .icon-wrapper
      display inline-block
      width 42px
      height 42px
      line-height 1
    .icon-type
      font-size 16px
      padding-bottom 15px
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_742367df"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_742367df"}
  /** script content **/
  require("./index.mpx.js?isPage!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=page&index=0&isPage&lang=js&mpx&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_742367df"],
    ctorType: "page",
    outputPath: "",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'icon-example':getComponent(require("./icon-example.mpx?isComponent&outputPath=components%2Ficon-example76a0aad7%2Findex")),'base-container':getComponent(require("../../components/base-container/index.mpx?isComponent&outputPath=components%2Findexa53ae8d2%2Findex")),'view-desc':getComponent(require("../../components/desc/index.mpx?isComponent&outputPath=components%2Findex590d50a3%2Findex")),'cube-icon':getComponent(require("../../../packages/mpx-cube-ui/src/components/icon/index.mpx?isComponent&outputPath=components%2Findex1d853680%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>